module.exports = __webpack_public_path__ + "img/t6-black.c0639ca0.png";